/* Sync only the last-chance percentage; Kaching continues to own offers/cart. */
(() => {
  'use strict';
  const widgets = new WeakSet();
  const selector = 'kaching-bundles-block';

  function bind(widget) {
    if (widgets.has(widget)) return;
    const root = widget.closest('[data-pv-product]');
    if (!root || root.dataset.mxKaching !== 'true') return;
    widgets.add(widget);
    let frame = 0;
    // Prefer the percentage shown on the selected Kaching deal bar (e.g. "AHORRA 60%").
    function barPercent() {
      const scopes = [widget, widget.shadowRoot].filter(Boolean);
      for (const scope of scopes) {
        const bars = Array.from(scope.querySelectorAll('[class*="bar"]')).filter(el => /(^|\s)[^\s]*bar(--|$|\s)/.test(el.className) || /__bar(\s|$)/.test(el.className));
        const selected = bars.find(el => /selected|active|checked/i.test(el.className) || el.getAttribute('aria-checked') === 'true' || el.getAttribute('aria-selected') === 'true' || el.querySelector('input[type="radio"]:checked'))
          || (scope.querySelector('input[type="radio"]:checked') || {}).closest?.('[class*="bar"], label');
        if (!selected) continue;
        const m = (selected.textContent || '').match(/(\d{1,2})\s*%/);
        if (m) return m[1];
      }
      return null;
    }
    function sync() {
      frame = 0;
      if (!widget.isConnected) return;
      const shown = barPercent();
      if (shown) {
        const t = root.querySelector('[data-pv-countdown-percent]');
        if (t && t.textContent.trim() !== shown) t.textContent = shown;
        return;
      }
      if (typeof widget.pricing !== 'function') return;
      let pricing;
      try { pricing = widget.pricing(); } catch (_) { return; }
      // Kaching's pricing() returns Money objects (amount + formatted).
      const full = pricing?.fullPrice?.amount;
      const discounted = pricing?.discountedPrice?.amount;
      if (!Number.isFinite(full) || !Number.isFinite(discounted) || full <= 0 || discounted < 0) return;
      const percent = String(Math.max(0, Math.min(100, Math.round((full - discounted) / full * 100))));
      const target = root.querySelector('[data-pv-countdown-percent]');
      if (target && target.textContent.trim() !== percent) target.textContent = percent;
    }
    function schedule() {
      if (!frame) frame = requestAnimationFrame(sync);
    }
    ['items-changed', 'deal-bar-selected', 'variant-selected', 'variants-changed', 'loaded'].forEach(event => {
      widget.addEventListener(event, schedule);
    });
    ['click', 'change'].forEach(event => widget.addEventListener(event, () => setTimeout(schedule, 80)));
    customElements.whenDefined(selector).then(() => { schedule(); setTimeout(schedule, 800); setTimeout(schedule, 2500); });
    schedule();
  }
  function scan(scope) {
    if (scope.matches?.(selector)) bind(scope);
    scope.querySelectorAll?.(selector).forEach(bind);
  }
  function start() {
    scan(document);
    // App embeds and the Shopify editor can insert/recreate widgets after load.
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType === 1) scan(node);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();

  document.addEventListener('click', event => {
    const link = event.target.closest?.('[data-mx-reviews-link]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const reviews = document.getElementById('mx-customer-reviews');
    if (!reviews) return;
    event.preventDefault();
    reviews.focus({ preventScroll: true });
    reviews.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    if (location.hash !== '#mx-customer-reviews') history.pushState(null, '', '#mx-customer-reviews');
  });
})();
